import React, { useCallback, useState } from "react";
import { api } from "@/lib/api";
import useFetch from "@/lib/useFetch";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";

function CheckInStatusBadge({ status }) {
  if (status === "follow_up") {
    return <Badge className="status-action border font-bold">FOLLOW-UP</Badge>;
  }
  return <Badge className="status-ok border font-bold">NO ISSUE</Badge>;
}

function CheckInsTable({ rows }) {
  return (
    <table className="w-full">
      <thead>
        <tr className="bg-slate-50 border-b border-slate-200">
          <th className="text-left text-xs uppercase tracking-wider text-slate-500 p-4">Date</th>
          <th className="text-left text-xs uppercase tracking-wider text-slate-500 p-4">Employee</th>
          <th className="text-left text-xs uppercase tracking-wider text-slate-500 p-4">Status</th>
          <th className="text-left text-xs uppercase tracking-wider text-slate-500 p-4">Note</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} className="border-b last:border-0">
            <td className="p-4 text-sm font-mono text-slate-700">{r.date}</td>
            <td className="p-4 text-sm font-medium text-slate-900">{r.worker_name}</td>
            <td className="p-4">
              <CheckInStatusBadge status={r.status} />
            </td>
            <td className="p-4 text-sm text-slate-600">{r.note || "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function CheckIns() {
  const fetcher = useCallback(() => api.get("/checkins").then((r) => r.data), []);
  const { data, loading } = useFetch(fetcher);
  const rows = data || [];
  const [filter, setFilter] = useState("");

  const filtered = rows.filter(
    (r) =>
      !filter ||
      r.worker_name.toLowerCase().includes(filter.toLowerCase()) ||
      r.date.includes(filter)
  );

  let body;
  if (loading) body = <p className="p-6 text-slate-500">Loading…</p>;
  else if (filtered.length === 0) body = <p className="p-10 text-center text-slate-500">No check-ins yet.</p>;
  else body = <CheckInsTable rows={filtered} />;

  return (
    <div className="space-y-6" data-testid="checkins-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Hand health
          </p>
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter text-slate-900 mt-1">
            Check-ins
          </h1>
          <p className="text-slate-600 mt-2 max-w-xl">
            Employees can flag a follow-up. No detailed medical info is stored —
            only the request and an optional note.
          </p>
        </div>
        <Input
          placeholder="Search employee or date…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="max-w-xs"
          data-testid="checkins-search"
        />
      </div>

      <Card className="border-slate-200">{body}</Card>
    </div>
  );
}
